import 'Styles/modals.scss';
import React from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { replace, goBack } from 'react-router-redux';

import Modal from 'Components/modals/ModalComponent';
import SvgIcon from 'Components/svg/SvgIcon';
import BanUserConfirmation from 'Components/modtools/banUserConfirmation';

import { hideUserModal, showReplyModal, showLoginModal } from 'Actions/UiActions';
import { banUser_confirm } from 'Actions/ModToolsActions';
import { currentUser, getUSerPermissions, getUserInfo } from 'Actions/ContextInfoActions';
import { trackGAEvent } from 'Actions/adsActions';

import { pathToUserProfile } from 'Utils/nav/NavHelpers';

export class UserModalComponent extends React.Component {

	shouldComponentUpdate( nextProps ) {
		return ( nextProps.isOpen !== this.props.isOpen );
	}

	componentDidUpdate( prevProps ) {
		if( prevProps.isOpen === false && prevProps.isOpen !== this.props.isOpen ) {
			// using pushState to avoid popstate to be triggered
			history.pushState( { topifyExtra: true, type: 'userModal' }, '', window.location );
		}
	}

	hideModalAndBack = () => {
		if( this.props.isOpen ) {
			this.props.dispatch( goBack() );
		}
	};

	hideModal() {
		this.props.dispatch( hideUserModal() );
	}

	get currentUser() {
		return this.props.dispatch( currentUser() );
	}

	get userPerms() {
		return this.props.dispatch( getUSerPermissions() );
	}

	sendMessage = () => {
		let userInfo = this.props.user.userName ? this.props.user : this.props.dispatch( getUserInfo( parseInt( this.props.user.id ) ) );
		this.hideModal();

		if( this.currentUser.id ) {
			this.props.dispatch( showReplyModal( { type: 'newMessage', user: userInfo } ) );
			// Record the Google Analytics event.
			this.props.dispatch( trackGAEvent( false, 'messageByUserModal', 'uiAction', 'tap' ) );

		} else {
			// for guests show the login modal
			this.props.dispatch( showLoginModal() );
			// Record the Google Analytics event.
			this.props.dispatch( trackGAEvent( false, 'messageByUserModal', 'userAction', 'loginPrompt' ) );
		}
	};

	showUserProfile() {
		this.hideModal();

		if( this.currentUser.id ) {
			this.props.dispatch( replace( pathToUserProfile( this.props.user.id ) ) );
			// Record the Google Analytics event.
			this.props.dispatch( trackGAEvent( false, 'userProfileByUserModal', 'uiAction', 'tap') );
		} else {
			// for guests show the login modal
			this.props.dispatch( showLoginModal() );
			// Record the Google Analytics event.
			this.props.dispatch( trackGAEvent( false, 'userProfileByUserModal', 'userAction', 'loginPrompt' ) );
		}
	}

	banUser( userId ) {
		let banType = ''; // from here just regular ban
		this.props.dispatch( banUser_confirm( userId, banType, ( type, content ) => <BanUserConfirmation type={ type } content={ content } /> ) );
		this.hideModal();
		// Record the Google Analytics event.
		this.props.dispatch( trackGAEvent( false, 'userBanByUserModal', 'uiAction', 'tap') );
	}

	moreOptions() {
		this.currentUser;
		let userPerms = this.userPerms;
		if( this.props.isOpen ) {
			// ModTools
			if( userPerms.modperms ) {
				if( userPerms.modperms.canbanusers && this.currentUser.id !== this.props.user.id ) {
					return <div className="action-button alert" onClick={ () => this.banUser( this.props.user.id ) }><SvgIcon size="32px" icon="block"/></div>
				}
			}
		}
		return null;
	}

	render() {
		const { user, defaultUrl } = this.props;

		let userImage = user.avatar ==='' ? defaultUrl : user.avatar,
			isGuest = !user.id;

		let sendMessage = !isGuest && this.currentUser.id !== user.id ? <div className="action-button" onClick={ this.sendMessage }><SvgIcon size="32px" icon="message"/></div> : null,
			moreOptions = !isGuest ? this.moreOptions() : null,
			showUserProfile = !isGuest ? <div className="action-button" onClick={ () => this.showUserProfile() }><SvgIcon size="32px" icon="account_circle"/></div> : null;

		return (
			<Modal isOpen={this.props.isOpen} onClickOutsideWindow={this.hideModalAndBack} className="user-modal">
				<span className="username">{ user.userName }</span>
				<div className="avatar"><img className="no-ad" src={ userImage } /></div>

				<div className="modal-buttons">
					{ sendMessage }
					{ moreOptions }
					{ showUserProfile }
				</div>
			</Modal>
		);
	}
}

UserModalComponent.defaultProps = {
	defaultUrl: ( 'https:' === document.location.protocol ? 'https://' : 'http://' ) + 'staticimages.topify.com/default_avatar.png'
};


UserModalComponent.propTypes = {
	isOpen: PropTypes.bool.isRequired,
	path: PropTypes.array.isRequired,
	user: PropTypes.object.isRequired
};

const mapStateToProps = ( state ) => {
	return {
		isOpen: state.ui.userModal.opened,
		path: state.ui.userModal.path,
		user: state.ui.userModal.user
	}
};

export default connect( mapStateToProps )( UserModalComponent );


// WEBPACK FOOTER //
// ./src/components/modals/UserModalComponent.js